import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { startSpinner,finishSpinner } from "../ui/spinner";

export const cuotasTraerStart = () => ({ type: types.cuotasTraerStart });
export const cuotasLimpiar = () => ({ type: types.cuotasLimpiar });
export const cuotasTraerError = (error) => ({ type: types.cuotasTraerError, payload: error});
export const cuotasSeleccionar = (payload) => ({ type: types.cuotasSeleccionar, payload: payload});
export const cuotasModificar = (payload) => ({ type: types.cuotasModificar, payload: payload});
export const cuotasEliminar = (payload) => ({ type: types.cuotasEliminar, payload: payload});
export const cuotasTraerSuccess = (payload) => {
    return {
        type: types.cuotasTraerSuccess,
        payload: payload
    }
}

export const fetchCuotas = () => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(cuotasTraerStart());
        const response = await fetchConToken(`Cuotas`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(cuotasTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const fetchCuotasPorDescripcion = (descripcion) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(cuotasTraerStart());
        const response = await fetchConToken(`Cuotas/traerPorDescripcion/${descripcion}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(cuotasTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const agregarEditarCuota = (cuota, callback) => {
  return async (dispatch,getState) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`Cuotas`, {...cuota}, 'POST');
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const item = await response.json();
        if (response.status !== 200) throw item.errores;
        const { items } = getState().cuotas;
        cuota.idCuota === 0 ? dispatch(cuotasTraerSuccess([...items, item])) : dispatch(cuotasModificar(item));
        dispatch( startAlerta(`La cuota se ${cuota.idCuota === 0 ? 'genero' : 'modifico'} correctamente`, "success", `Exito!`) );
        callback&& callback();
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const eliminarCuota = (idCuota) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        const response = await fetchConToken(`Cuotas`, {idCuota}, 'DELETE');
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const item = await response.json();
          if (response.status !== 200) throw item.errores;
          dispatch( cuotasEliminar(idCuota) );
          dispatch( startAlerta("La cuota se elimino correctamente", "success", `Exito!`) );
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};